import { combineReducers } from 'redux'

import oil from './OilSearch/oilSearchSlice'

export default combineReducers({
	oil
})